module.exports = __webpack_public_path__ + "img/icon-sadadream.ef1898f7.svg";